export default __webpack_public_path__ + "static/media/floorStaff.d0e47b23.svg";